import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import modals from '../../../enums/modals';
import { startScheduleRoute } from '../../../store/actions/schedule';
import { wrapPromise } from '../../../utils/promise';
import useSummaryModalData from './useSummaryModalData';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

const useTransferToModalData = () => {
  const dispatch = useDispatch();
  const { getModalRef } = useModalContext();
  const { openSummaryModal } = useSummaryModalData();

  const openTransferToModal = useCallback(
    async ({ isStopsSelected }) => {
      const transferToModalRef = getModalRef(modals.TRANSFER_TO);
      const [result = {}, canceled] = await wrapPromise(
        transferToModalRef.current.showModal({
          isStopsSelected,
        })
      );
      if (canceled) {
        return;
      }
      const { optimise, transferOnly } = result;
      !transferOnly
        ? dispatch(startScheduleRoute(optimise))
        : openSummaryModal({ isTransfer: true });
    },
    [openSummaryModal, dispatch]
  );

  return {
    openTransferToModal,
  };
};

export default useTransferToModalData;
